import { CONTAINERS, FROM, preCOLS } from "../libraries/utils";
import {etiqueta, etiqueta2, eliminarMensajes } from "./function";

let primerIngreso = true;

const aid = function () {
  let $res = $(".res");

  $res.each(function () {
    //Configuración  de test --------------------
    //variables
    const $testComponent = $(this);

    // recorre la función para cada par (clave, valor)
    let anchoPantalla = window.innerWidth;

    //Eliminar mensajes
    eliminarMensajes();

    //Creando viewport
    if(!$('body').find('.test-viewport').length){
      $('body').append(`
        <cite class="test-viewport"></cite>
      `);
    }

    etiqueta($('body').find('.test-viewport'), `${FROM(anchoPantalla)}: ${anchoPantalla}px`);

    primerIngreso = false;
  });
};

document.addEventListener("DOMContentLoaded", aid);
document.addEventListener("resize", aid);
$(document).ready(function () {
  // actualizaremos el zoom cuando la ventana cambie de tamaño
  $(window).on("resize", aid);
});
